import React, { useEffect, useState } from "react";
import {
  DetailCard,
  IconDisplay,
  ActionIcon,
  PaginatedTable,
  DateTimePickerInput,
  TextField,
} from "components";
import { getTableDisplayConfig } from "displayConfigs";
import { VendorServices } from "services";
import { generateQueryParamsFromObject } from "utils";
import "./index.css";
import "./tablet.css";
import "./mobile.css";

const TransactionsList = ({ vendorId }) => {
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [vendorTransactionsList, setVendorTransactionsList] = useState([]);

  useEffect(() => {
    fetchVendorTransactions();
  }, [fromDate, toDate, searchTerm]);

  const transactionConfig = getTableDisplayConfig("Transaction", {
    actions: ({ transactionType }) => (
      <>
        <ActionIcon
          type={
            transactionType === "CREDIT"
              ? "creditTransaction"
              : "debitTransaction"
          }
          iconClassName={`listIcon--${
            transactionType === "CREDIT" ? "increment" : "decrement"
          }`}
        />
      </>
    ),
  });

  const fetchVendorTransactions = async () => {
    try {
      setLoading(true);
      const query = generateQueryParamsFromObject({
        vendorId,
        pageNum: 0,
        pageLimit: 10,
        fromDate,
        toDate,
        searchTerm,
      });
      const { transactionsList } = await VendorServices.fetchTransactionsList(
        query
      );
      setVendorTransactionsList(transactionsList);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setVendorTransactionsList([]);
    }
  };

  return (
    <>
      <DetailCard
        className="vendorDashboard__gridContainer--vendorTransactions"
        headerClass="vendorDashboard__gridContainer--vendorTransactions-header"
        headerContent={
          <>
            <span className="vendorDashboard__gridContainer--vendorTransactions-header-name">
              <IconDisplay
                type="cash"
                className="vendorDashboard__gridContainer--vendorTransactions-icon"
              />{" "}
              All Transactions
            </span>

            <div className="div__Filters">
              <DateTimePickerInput
                inputType="Date"
                className="vendorDashboard__gridContainer--vendorTransactions-fromDate"
                placeholder="From"
                dateValue={fromDate || null}
                handleChange={(dateVal) => setFromDate(dateVal?._d.toISOString())}
              />
              <DateTimePickerInput
                inputType="Date"
                className="vendorDashboard__gridContainer--vendorTransactions-toDate"
                dateValue={toDate || null}
                placeholder="To"
                handleChange={(dateVal) => setToDate(dateVal?._d.toISOString())}
              />
              <TextField
                className="vendorDashboard__gridContainer--vendorTransactions-searchFilter"
                placeholder="Search by Transaction Id"
                value={searchTerm || ``}
                onChange={({ target }) => setSearchTerm(target.value)}
              />
            </div>
            
          </>
        }
        contentClass="vendorDashboard__gridContainer--vendorTransactions-content"
        cardContent={
          <PaginatedTable
            config={transactionConfig}
            dataList={vendorTransactionsList}
            loading={loading}
          />
        }
      />
    </>
  );
};

export default TransactionsList;
